import { logger } from '@fiverr-private/obs';
import { isBrowser } from './isBrowser';

// README: https://docs.fiverr-gw.com/platform/perseus/migration/migrating_from_v2#no-more-window-over-node
export const getWindow = (): undefined | Window => (isBrowser() ? window : undefined);

export const getDocument = () => getWindow()?.document;

interface NestedDataObject {
    [key: string]: string | NestedDataObject;
}
export interface OpenLoginModalOptions {
    source: string;
    data: NestedDataObject;
    type: string;
}

export const handleSignUpModalOpen = ({ source, data, type }: OpenLoginModalOptions): void => {
    const signUpModalHandler: Window['openSignUpModal'] | undefined = getWindow()?.openSignUpModal;

    if (!signUpModalHandler) {
        logger.error('No sign up modal handler found');
        return;
    }

    signUpModalHandler(
        {
            triggerCta: {
                source,
                type,
                data,
            },
        },
        { source }
    );
};
